<template>
<div :class="{root: true, sidebarStatic}" class="">

  <Sidebar :sidebar="sidebar"/>
  <div class="wrap">
   <Header  :sidebar="sidebar" />
<b-alert show variant="warning" v-if="activeSite && activeSite.demo && ['Dashboard', 'ExplorePage', 'ExplorePageDetails', 'ExploreLinkDetails', 'ExploreImageDetails', 'ExploreResourceDetails', 'LinksPage', 'BrokenImagesPage', 'LayoutIssuesPage', 'SpellingPage', 'DictionaryPage', 'JavascriptPage', 'LogDetails', 'BrokenLinksPage', 'BrokenResourcesPage'].includes($route.name)">
  <span v-if="user.role === 'user'">This is a demo report, you can add your site using the New Site link above.</span>
  <span v-else>This is a demo report, you can <a href="https://app.pagewatch.dev/register">sign up</a> to check your own site.</span>
  </b-alert>
  <router-view />
  </div>
</div>

</template>

<script>
import { mapState, mapActions } from 'vuex';

import Sidebar from '@/components/Sidebar/Sidebar';
import Header from '@/components/Header/Header';
import Helper from '@/components/Helper/Helper';

import './Layout.scss';

export default {
  name: 'Layout',
  components: { Sidebar, Header, Helper },
  data() {
    return {
      sidebar: { expanded: false }
    };
  },
  methods: {
    ...mapActions(
      'layout', ['changeSidebarActive'],
    ),
  },
  computed: {
    ...mapState({layout: 'layout', user: 'user', activeSite: 'activeSite',  sidebarStatic: state => state.sidebarStatic,
    }),
  },
  created() {
    const staticSidebar = true;

    if (staticSidebar) {
      this.$store.state.layout.sidebarStatic = true;
    }
  },
};
</script>

<style src="./Layout.scss" lang="scss" />
